import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { invalidateRequests } from 'redux-bees'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ROUTES } from '../../constants'
import { formatCurrency, isPaid, urlFor } from 'utils'
import api from 'api'
import { Notice } from 'components'

export default connect(
  null,
  {
    invalidateRegistrations: () => async dispatch => {
      dispatch(invalidateRequests(api.getCampers))
    }
  }
)(class DashboardCamperRegistration extends React.Component {
  deleteRegistration(id) {
    api.deleteRegistration({ id: id }).then(() => this.props.invalidateRegistrations())
  }
  render() {
    const { registration, areaCamp: getAreaCamp, payments: getPayments, healthForm: getHealthForm, camper } = this.props
    const areaCamp = getAreaCamp(registration)
    const payments = getPayments(registration)
    const healthForm = getHealthForm(registration)
    const enforceHealthFormQuota = !!(areaCamp && areaCamp.attributes && areaCamp.attributes['enforce-health-form-for-quota'])

    return (
      <Fragment>
        <td>{areaCamp ? areaCamp.attributes.name : <i>Missing area camp</i>}</td>
        {healthForm ? (
          <td>
            {healthForm.attributes.status} (
            <Link to={urlFor(ROUTES.healthForms.edit, { id: healthForm.id })}>edit</Link>)
          </td>
        ) : (
          <td>N/A</td>
        )}
        <td>
          {registration.attributes.waitlisted ? (
            'Waitlist'
          ) : registration.attributes.is_fully_paid ? (
            'Fully Paid'
          ) : (
            <Fragment>
              Paid: ${formatCurrency(registration.attributes.balance)}
              <br />
            </Fragment>
          )}
        </td>
        <td>
          {enforceHealthFormQuota && (!healthForm || healthForm.attributes.status === 'Incomplete') && !(camper && camper.attributes && camper.attributes['yl-leader'] === true) && (
            <Notice type="alert">
               <p><span role="img" aria-label="rotating-light">🚨</span> Please complete the health form, to finalize your registration reservation.</p>
            </Notice>
          )}
        </td>
        <td style={{ textAlign: 'right' }}>
          {registration.attributes.waitlisted ? (
            <Fragment>
              {areaCamp && areaCamp.attributes.active && (
                <Link to={urlFor(ROUTES.registrations.edit, { id: registration.id })} className="btn sm default">
                  <FontAwesomeIcon icon={['far', 'edit']} />
                </Link>
              )}
              <button
                onClick={() =>{
                  const campName = (areaCamp && areaCamp.attributes && areaCamp.attributes.name) ? areaCamp.attributes.name : 'Unknown';

                  // Use CRLF for widest client support (Outlook, etc.)
                  const bodyPlain = [
                    'Before you hit SEND please help us direct your cancellation request to the correct local area, by answering these questions:',
                    '',
                    'Camper Name:',
                    '',
                    `Camp: ${campName}`,
                    '',
                    'Local Young Life area:',
                    '',
                    'Any other info we need to know?'
                  ].join('\r\n');

                  const mailto = `mailto:camppayments@younglife.ca` +
                    `?subject=${encodeURIComponent('Cancel Registration Request')}` +
                    `&body=${encodeURIComponent(bodyPlain)}`;

                  window.location.href = mailto;
                }}
                className="btn sm danger"
              >
                <span>Cancel</span>
              </button>
            </Fragment>
          ) : (
            <Fragment>
              {areaCamp && areaCamp.attributes.active && (
                <Link to={urlFor(ROUTES.registrations.edit, { id: registration.id })} className="btn sm gray">
                  <FontAwesomeIcon icon={['far', 'edit']} />
                </Link>
              )}
              {payments && payments.length === 0 && (
                <button
                onClick={() => {
                  const campName = (areaCamp && areaCamp.attributes && areaCamp.attributes.name) ? areaCamp.attributes.name : 'Unknown';

                  // Use CRLF for widest client support (Outlook, etc.)
                  const bodyPlain = [
                    'Before you hit SEND please help us direct your cancellation request to the correct local area, by answering these questions:',
                    '',
                    'Camper Name:',
                    '',
                    `Camp: ${campName}`,
                    '',
                    'Local Young Life area:',
                    '',
                    'Any other info we need to know?'
                  ].join('\r\n');

                  const mailto = `mailto:camppayments@younglife.ca` +
                    `?subject=${encodeURIComponent('Cancel Registration Request')}` +
                    `&body=${encodeURIComponent(bodyPlain)}`;

                  window.location.href = mailto;
                }}
                  className="btn sm danger"
                >
                  {/* TODO: add real link */}
                  <span>Cancel</span>
                </button>
              )}
              {!isPaid(registration.attributes.balance, registration.attributes.fee) && (
                <Link
                  to={urlFor(ROUTES.payments.new, { id: registration.attributes['token'] })}
                  className="btn inline info"
                  style={{ fontSize: '1em', padding: '8px 16px' }}
                >
                  <span className="hide-mobile">Make Payment</span>
                  <span className="hide-desktop">Pay</span>
                </Link>
              )}
            </Fragment>
          )}
        </td>
      </Fragment>
    )
  }
})
